import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '../../utils/cn';

export interface MarkdownContentProps {
  content: string;
  className?: string;
}

/**
 * Reusable component for rendering markdown content with consistent styling.
 * Uses react-markdown with GitHub Flavored Markdown support.
 * Leverages Tailwind's prose classes for beautiful typography.
 */
export const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  className
}) => {
  return (
    <div className={cn(
      'prose prose-sm dark:prose-invert max-w-none',
      // Customize prose styles for better integration with our theme
      'prose-headings:text-foreground prose-p:text-foreground',
      'prose-strong:text-foreground prose-code:text-foreground',
      'prose-a:text-primary hover:prose-a:underline',
      'prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground',
      'prose-hr:border-border',
      className
    )}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;
